import React, {useEffect, useState} from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "../../style/datePicker.css"
import {Input} from "@material-tailwind/react";

const DateField = ({className, date, setDate, label, placeholder, inputProps = {}}) => {

  // do NOT default to today
  const [curDate, setCurDate] = useState(date ?? null);

  useEffect(() => {
    setCurDate(date ?? null);
  }, [date]);

  useEffect(() => {
    if (curDate && curDate?.month !== undefined) {
      const selectedDate =
        curDate.year +
        "-" +
        curDate.month.toString().padStart(2, "0") +
        "-" +
        curDate.day.toString().padStart(2, "0");

      setDate(selectedDate);
    }

    if (!curDate) {
      setDate(null);
    }

  }, [curDate]);

  return (
    <div style={{direction: "rtl"}} className={className}>
      <DatePicker
        calendar={persian}
        className="rmdp-calendar"
        render={
          <Input
            label={label}
            placeholder={placeholder}
            variant="standard"
            className="w-full"
            {...inputProps}
          />
        }
        value={curDate}              // no fallback
        onChange={setCurDate}
        locale={persian_fa}
        calendarPosition="bottom-right"
        editable={false}
      />
    </div>
  );
};

export default DateField;
